import alt from 'components/Dispatcher';

class TrendPivotChartActions {
  constructor() {
    this.generateActions(
      'searchTrend',
      'searchPivot',

      'toggleShowTrendChart',

      'clearPivotState',

      'searchTrendLoading',
      'searchTrendError',
      'searchTrendSuccess',

      'searchPivotLoading',
      'searchPivotError',
      'searchPivotSuccess',

      'switchSearchMaxDate'
    );
  }
}

export default alt.createActions(TrendPivotChartActions);
